import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "hero" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Let's Pool"),
  /*#__PURE__*/_createElementVNode("p", { id: "subtitle" }, "We gonna play billard, we gonna learn physics and threejs here, and the goal is just to have fun")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "footer" }, [
  /*#__PURE__*/_createTextVNode(" © Following "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://niklever.com/courses/",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "link"
  }, "Nicholas Lever tutorial")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}